import { CustomFields } from './CustomFieldsDto';

/* eslint-disable @typescript-eslint/naming-convention */
export interface AbsorbUserDto {
  Id: string;
  DepartmentId: string;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  Username: string;
  Password: string;
  EmailAddress: string;
  ExternalId: string;
  CcEmailAddresses: string[];
  LanguageId: number;
  Gender: number;
  Address: string;
  Address2: string;
  City: string;
  ProvinceId: string;
  CountryId: string;
  PostalCode: string;
  Phone: string;
  EmployeeNumber: string;
  Location: string;
  JobTitle: string;
  ReferenceNumber: string;
  DateHired: Date | null;
  DateTerminated: Date | null;
  Notes: string;
  CustomFields: CustomFields;
  RoleIds: string[];
  ActiveStatus: number;
  IsLearner: boolean;
  IsAdmin: boolean;
  IsInstructor: boolean;
  SupervisorId: string | null;
  HasUsername: boolean;
  Class: string;
  PRCo: number;
  State: string;
  OccupationalCategory: string;
}
